import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, trySearchFeatureKey } from '../reducers/try-search.reducer';

const trySearchState = createFeatureSelector<State>(trySearchFeatureKey);

export const getKakomonImage = createSelector(trySearchState, (state: State) => {
  return state.kakomonImages;
});
